export const translateProductNameCallback = (i18n, t) => (key) => {
  if (i18n.exists(`${key}.0`)) {
    return t(`${key}.0`);
  }

  return t(`${key}`);
};
